export default __webpack_public_path__ + "static/media/25081105.5bbd716d.png";